var _a;
import { ARK_DOMAIN, FRODO_DOMAIN, HTTPS_CDN, FRODO_SCHEMA, TALION_FRODO_API } from './consts';
export var STATUS = {
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
export var IS_DEV = typeof DEV !== 'undefined';
export var IS_PROD = typeof process !== 'undefined' && 'production' === process.env.NODE_ENV;
var ua = navigator.userAgent.toLowerCase();
var os;
if (/android/i.test(ua)) {
    os = 'android';
}
else if (/ipad|iphone|ipod/.test(ua)) {
    os = 'ios';
}
else {
    os = 'unknown';
}
var isDoubanapp = /com\.douban\.(frodo|movie)/.test(ua);
var isDoubanappTest = /com\.douban\.(frodo|movie)\.test/.test(ua);
var isDoubanMovie = /com\.douban\.(douban)?movie/.test(ua);
var isTalion = document.domain === 'm.douban.com' ||
    (IS_DEV && typeof process !== 'undefined' && process.env.MODE === 'talion');
if (IS_DEV && isTalion) {
    document.body.style.maxWidth = '650px';
    document.body.style.margin = '0 auto';
}
var isMiniProgram = (function () {
    // https://developers.weixin.qq.com/community/develop/doc/000688811bc278ab99f69ff1256000?jumpto=comment&commentid=00062ea83d8b5821703776d5f518
    if (window['__wxjs_environment'] === 'miniprogram' || ua.indexOf('miniprogram') !== -1) {
        return true;
    }
    return false;
})();
export var IS_DOUBANAPP = isDoubanapp;
export var IS_DOUBANAPP_TEST = isDoubanappTest;
export var IS_DOUBAN_MOVIE = isDoubanMovie;
export var IS_TALION = isTalion;
export var IS_TIME_DESKTOP = document.domain === 'time.douban.com' || (!isTalion && !isDoubanapp);
export var IS_MINIPROGRAM = isMiniProgram;
export var OS = os;
export var M_SITE_MAX_WIDTH = 650;
/**
 * 获得最大页面宽度，如果是 m 站则最650,
 */
export var getMaxWinWidth = function () {
    //NOTE: chrome 的 window.innerWidth 会包含滚动条，所以这里取 html 节点的 clientWidth
    return IS_TALION
        ? Math.min(M_SITE_MAX_WIDTH, document.documentElement.clientWidth)
        : window.innerWidth;
};
export var MAX_WIN_WIDTH = getMaxWinWidth();
export var M_SITE_NAV_HEIGHT = 47;
export var M_SITE_FIXED_CLS = 'msite-fixed-max-width';
export var IS_DESKTOP = OS === 'unknown' && IS_TALION;
export var BLACK_NAV_HEIGHT = 28;
var apiPrefix = FRODO_DOMAIN;
if (IS_PROD && IS_TALION) {
    apiPrefix = TALION_FRODO_API;
}
else if (IS_DEV && (!DEV.INAPP || DEV.PRE)) {
    apiPrefix = DEV.SERVE_PATH || '';
}
export var API_PREFIX = apiPrefix;
var arkApiPrefix = ARK_DOMAIN;
if (IS_DEV && (!DEV.INAPP || DEV.PRE)) {
    // Use local server to handle cross domain request. No cookie will be added.
    arkApiPrefix = DEV.SERVE_PATH || '';
}
export var ARK_API_PREFIX = arkApiPrefix;
export var SUPPORT_APPS = [
    {
        scheme: 'tenvideo2',
        package_name: 'com.tencent.qqlive',
    },
    {
        scheme: 'youku',
        package_name: 'com.youku.phone',
    },
    {
        scheme: 'iqiyi',
        package_name: 'com.qiyi.video',
    },
    {
        scheme: 'pptv',
        package_name: 'com.pplive.androidphone',
    },
    {
        scheme: 'sohuvideo',
        package_name: 'com.sohu.sohuvideo',
    },
    {
        scheme: 'imgotv',
        package_name: 'com.hunantv.imgo.activity',
    },
    {
        scheme: 'bilibili',
        package_name: 'tv.danmaku.bili',
    },
    {
        scheme: 'letvclient',
        package_name: 'com.letv.android.client',
    },
    {
        scheme: 'igetapp',
        package_name: 'com.luojilab.player',
    },
    {
        scheme: 'bookclub',
        package_name: 'io.dushu.fandengreader',
    },
];
export var APPS_CHECK_LIST = (_a = {},
    _a["".concat(os === 'android' ? 'package_names' : 'schemes')] = SUPPORT_APPS.map(function (app) {
        return os === 'android' ? app.package_name : app.scheme;
    }),
    _a);
export default {
    STATUS: STATUS,
    API_PREFIX: API_PREFIX,
    IS_DOUBANAPP: IS_DOUBANAPP,
    IS_DOUBAN_MOVIE: IS_DOUBAN_MOVIE,
    OS: OS,
    HTTPS_CDN: HTTPS_CDN,
    APPS_CHECK_LIST: APPS_CHECK_LIST,
    IS_TALION: IS_TALION,
    M_SITE_FIXED_CLS: M_SITE_FIXED_CLS,
    FRODO_SCHEMA: FRODO_SCHEMA,
};
//# sourceMappingURL=Globals.js.map